// extracted by mini-css-extract-plugin
export default {"app_wrapper":"app_app_wrapper__5oOa-","section_wrapper":"app_section_wrapper__Jxqs+","section__title":"app_section__title__pbJ62"};